import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAlert = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.0191 3.27274C12.5566 3.27274 13.0557 3.57955 13.3244 4.03978L21.6166 18.1534C21.8853 18.652 21.8853 19.2273 21.6166 19.6875C21.3479 20.1861 20.8488 20.4546 20.3113 20.4546H3.72695C3.1511 20.4546 2.65204 20.1861 2.38331 19.6875C2.11458 19.2273 2.11458 18.652 2.38331 18.1534L10.6755 4.03978C10.9442 3.57955 11.4433 3.27274 12.0191 3.27274ZM12.0191 8.18183C11.4817 8.18183 11.0978 8.6037 11.0978 9.10228V13.3977C11.0978 13.9347 11.4817 14.3182 12.0191 14.3182C12.5182 14.3182 12.9405 13.9347 12.9405 13.3977V9.10228C12.9405 8.6037 12.5182 8.18183 12.0191 8.18183ZM13.2476 16.7727C13.2476 16.1207 12.6718 15.5455 12.0191 15.5455C11.3281 15.5455 10.7907 16.1207 10.7907 16.7727C10.7907 17.4631 11.3281 18 12.0191 18C12.6718 18 13.2476 17.4631 13.2476 16.7727Z",
		fill: "currentColor"
	})
});
export default SvgAlert;
